import React, { } from "react";
import { Box } from "@mantine/core";
import {
    IconTransform,
    IconTemplate,
    IconHome,
    IconMapRoute,
    IconPlugConnected,
    IconBinoculars,
    IconUser,
    IconKey,
    IconShieldLock,
    IconUsers,
    IconSettingsAutomation
} from '@tabler/icons-react'
import { Navbar } from "../components/Navbar/Navbar";
import NavbarSection from "../components/Navbar/NavbarSection";
import { Grid } from "@mui/material";
import NavbarLink from "../components/Navbar/NavbarLink";
import NavPageHeader from "../components/Navbar/NavPageHeader";
import NavbarAccountSection from "../components/Navbar/NavbarAccountSection";
import NavbarHeader from "../components/Navbar/NavbarHeader";
import NavbarContainer from "../components/Navbar/NavbarContainer";

function NavLinks() {
    return (
        <NavbarContainer>
            <NavbarHeader />

            <Navbar>
                <NavbarSection title="Dashboards" requiredRoles={["User"]}>
                    <NavbarLink href="/" label="Home" icon={<IconHome size={"1.125rem"} />} />
                </NavbarSection>

                <NavbarSection title="IT Service" requiredRoles={["HR", "IT"]}>
                    <NavbarLink
                        href="/it-service/change-management"
                        label="Change Management"
                        icon={<IconTransform size={"1.125rem"} />}
                    />
                    {/* <NavbarLink
                                href="/it-service/mail"
                                label="Mail"
                                icon={<IconMail size={"1.125rem"} />}
                                requiredRoles={["IT"]}
                            /> */}
                    <NavbarLink
                        href="/it-service/active-employees"
                        label="Employees"
                        icon={<IconUsers size={"1.125rem"} />}
                    />
                </NavbarSection>

                <NavbarSection title="Settings" requiredRoles={["Admin", "Automation Administrator"]}>
                    <NavbarLink href="/settings/api-keys" label="API Keys" icon={<IconKey size={"1.125rem"} />} requiredRoles={["Admin"]} />
                    <NavbarLink href="/settings/integrations" label="Integrations" icon={<IconPlugConnected size={"1.125rem"} />} requiredRoles={["Admin"]} />
                    <NavbarLink href="/settings/templates" label="Templates" icon={<IconTemplate size={"1.125rem"} />} requiredRoles={["Admin"]} />
                    <NavbarLink
                        href="/settings/automations" label="Automations"
                        icon={<IconSettingsAutomation size={"1.125rem"} />}
                        requiredRoles={["Admin", "Automation Administrator"]}
                    />
                </NavbarSection>

                <NavbarSection title="Security" requiredRoles={["Admin"]}>
                    <NavbarLink href="/security/roles" label="Roles" icon={<IconUser size={"1.125rem"} />} />
                    <NavbarLink href="/security/sessions" label="Sessions" icon={<IconShieldLock size={"1.125rem"} />} />
                </NavbarSection>

                <NavbarSection title="Reporting" requiredRoles={["Admin"]}>
                    <NavbarLink href="/reporting/audit-logs" label="Audit Logs" icon={<IconBinoculars size={"1.125rem"} />} />
                </NavbarSection>

                <NavbarSection title="Developer" requiredRoles={["Admin"]}>
                    <NavbarLink href="/developer/roadmap" label="Roadmap" icon={<IconMapRoute size={"1.125rem"} />} />
                </NavbarSection>
            </Navbar>

            <NavbarAccountSection visibleFrom={"lg"} />
        </NavbarContainer>
    )
};

function PageContent({ children }) {
    return (
        <Box style={{
            height: "100%",
            backgroundColor: "var(--page-body-color)",
            border: "1px solid var(--border-color)",
            borderRadius: "var(--border-radius)",
            boxShadow: "var(--drop-shadow)",
        }}>
            <NavPageHeader navDrawerContents={<NavLinks />} />

            {/* Calculate total height minus the nav header */}
            <Box h="calc(100% - 71px)">
                {children}
            </Box>
        </Box>
    )
}

function DashboardLayout({ children }) {
    return (
        <Grid container>
            <Grid size={{ xs: 0, lg: "auto" }} sx={{ display: { xs: 'none', lg: 'block' } }}>
                <NavLinks />
            </Grid>
            <Grid
                size={{ xs: 12, lg: "grow" }}
                sx={{
                    margin: {
                        xs: "16px",
                        lg: "16px 16px 16px 0px"
                    }
                }}
            >
                {children}
            </Grid>
        </Grid>
    )
}

export {
    DashboardLayout,
    PageContent
}